module.exports = __webpack_public_path__ + "img/multiplier_normal_3.1331ba43.png";